import { useAppDispatch, useAppSelector } from '../hooks';
import HelpTabIcon from 'assets/icons/help-tab-icon.svg';
import ArticlesTabIcon from 'assets/icons/articles-tab-icon.svg';
import { selectFeatureFlags } from 'reducers/workflows';
import {
  selectLegibleIconColor,
  selectWidgetArticleConfig,
} from 'reducers/config';
import { selectIsArticlePage, selectSelectedTab } from 'reducers/main';
import { Tabs } from '@forethought-technologies/forethought-elements';
import { setSelectedTab } from 'actions/main';
import { Box, useTheme } from '@mui/material';
import { ReactSVG } from 'react-svg';

function a11yProps(index: number) {
  return {
    'aria-controls': `simple-tabpanel-${index}`,
    id: `simple-tab-${index}`,
  };
}

export default function MainTabs() {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const featureFlags = useAppSelector(selectFeatureFlags);
  const isArticlePage = useAppSelector(selectIsArticlePage);
  const selectedTab = useAppSelector(selectSelectedTab);
  const legibleIconColor = useAppSelector(selectLegibleIconColor);
  const widgetArticleSearchConfig = useAppSelector(selectWidgetArticleConfig);
  const isSolveUiTabsEnabled =
    featureFlags.includes('solve_ui_tabs') && widgetArticleSearchConfig.enabled;

  return (
    isSolveUiTabsEnabled && (
      <Box
        sx={{
          background: theme.palette.background.default,
          display: isArticlePage ? 'none' : undefined,
          paddingTop: selectedTab === 0 ? '16px' : undefined,
          width: '100%',
        }}
      >
        <Tabs
          a11yProps={a11yProps}
          aria-label='Main tabs'
          ContainerProps={{
            border: 'none',
          }}
          onChange={(_, newValue) => dispatch(setSelectedTab(newValue))}
          sx={{
            '.MuiTab-root': {
              ':hover': {
                borderBottom: 'none',
                borderTop: `1px solid ${legibleIconColor}`,
              },
              borderBottom: 'none',
              borderTop: '1px solid transparent',
            },
            '.MuiTabs-indicator': {
              backgroundColor: legibleIconColor,
              top: 0,
            },
          }}
          tabs={[
            <Box
              alignItems='center'
              display='flex'
              flexDirection='column'
              key={0}
            >
              <ReactSVG
                src={HelpTabIcon}
                style={{
                  color: selectedTab === 0 ? legibleIconColor : undefined,
                }}
              />
              Help
            </Box>,
            <Box
              alignItems='center'
              display='flex'
              flexDirection='column'
              key={1}
            >
              <ReactSVG
                src={ArticlesTabIcon}
                style={{
                  color: selectedTab === 1 ? legibleIconColor : undefined,
                }}
              />
              Articles
            </Box>,
          ]}
          typographyVariant='font14Bold'
          value={selectedTab}
          variant='fullWidth'
        />
      </Box>
    )
  );
}
